var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonFootprint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "carbonFootprint") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.2931708%",
    y1: "56.4987058%",
    x2: "46.2934041%",
    y2: "47.3653432%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0.0136582168%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BF782",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,53 C56.0685425,53 69.5,48.2989899 69.5,42.5 C69.5,36.7010101 56.0685425,32 39.5,32 C22.9314575,32 9.5,36.7010101 9.5,42.5 C9.5,48.2989899 22.9314575,53 39.5,53 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-26.7%",
    y: "-66.7%",
    width: "153.3%",
    height: "252.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.101960784   0 0 0 0 0.925490196   0 0 0 0 0.295416972  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.7232726%",
    y1: "100%",
    x2: "47.7232726%",
    y2: "33.1219281%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EE867",
    offset: "0.0136582168%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BF783",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.2931708%",
    y1: "56.4987058%",
    x2: "46.2934041%",
    y2: "47.3653432%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EE881",
    offset: "0.0136582168%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BF795",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,47 C56.0685425,47 69.5,42.2989899 69.5,36.5 C69.5,30.7010101 56.0685425,26 39.5,26 C22.9314575,26 9.5,30.7010101 9.5,36.5 C9.5,42.2989899 22.9314575,47 39.5,47 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-26.7%",
    y: "-66.7%",
    width: "153.3%",
    height: "252.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.101960784   0 0 0 0 0.925490196   0 0 0 0 0.749026839  0 0 0 0.503109805 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.8098591%",
    y1: "46.5027356%",
    x2: "84.7958158%",
    y2: "53.8012349%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17EB65",
    offset: "0.0136582168%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BF782",
    offset: "51.5706949%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.48964329,26.0524414 C6.94439586,27.6738631 5.5,29.5290271 5.5,31.5 C5.5,36.4614003 14.6523674,40.6889804 27.4774429,42.3016634 M39,43 C57.5015391,43 72.5,37.8512746 72.5,31.5 C72.5,25.1487254 57.5015391,20 39,20 C33.0136153,20 27.3939748,20.5390304 22.5304767,21.4834173",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-47.0%",
    y: "-128.3%",
    width: "194.0%",
    height: "373.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.349019608   0 0 0 0 0.843137255   0 0 0 0 0.266666667  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "1.01156168%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DE1A1",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DE160",
    stopOpacity: 0.383433949,
    offset: "54.7366696%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DE17C",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "-2.22044605e-14%",
    y2: "50%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DEA43",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23E994",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "-2.22044605e-14%",
    y2: "50%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DEA43",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23E994",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FD\\u5E73-\\u4EA7\\u54C1\\u78B3\\u8DB3\\u8FF9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6289-\\u7B2C\\u4E09\\u6B65-LCA-\\u7ED3\\u679C",
    transform: "translate(-58.000000, -2332.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "carbonFootprint",
    transform: "translate(58.000000, 2332.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5E95\\u5EA714",
    transform: "translate(4.500000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u692D\\u5706\\u5F62"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-1)",
    strokeWidth: 1,
    d: "M39.5,32.5 C47.7192298,32.5 55.1613681,33.6619769 60.5480282,35.547308 C63.24525,36.4913356 65.4221559,37.6131599 66.9054521,38.8665077 C68.2301519,39.9858455 69,41.2033033 69,42.5 C69,43.7966967 68.2301519,45.0141545 66.9054521,46.1334923 C65.4221559,47.3868401 63.24525,48.5086644 60.5480282,49.452692 C55.1613681,51.3380231 47.7192298,52.5 39.5,52.5 C31.2807702,52.5 23.8386319,51.3380231 18.4519718,49.452692 C15.75475,48.5086644 13.5778441,47.3868401 12.0945479,46.1334923 C10.7698481,45.0141545 10,43.7966967 10,42.5 C10,41.2033033 10.7698481,39.9858455 12.0945479,38.8665077 C13.5778441,37.6131599 15.75475,36.4913356 18.4519718,35.547308 C23.8386319,33.6619769 31.2807702,32.5 39.5,32.5 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-5)",
    strokeWidth: 2,
    d: "M39.5,27 C47.6541883,27 55.0384649,28.1487013 60.382853,30.0192372 C63.0113073,30.9391962 65.1367388,32.0265853 66.5827435,33.2484228 C67.7682045,34.2501074 68.5,35.3288365 68.5,36.5 C68.5,37.6711635 67.7682045,38.7498926 66.5827435,39.7515772 C65.1367388,40.9734147 63.0113073,42.0608038 60.382853,42.9807628 C55.0384649,44.8512987 47.6541883,46 39.5,46 C31.3458117,46 23.9615351,44.8512987 18.617147,42.9807628 C15.9886927,42.0608038 13.8632612,40.9734147 12.4172565,39.7515772 C11.2317955,38.7498926 10.5,37.6711635 10.5,36.5 C10.5,35.3288365 11.2317955,34.2501074 12.4172565,33.2484228 C13.8632612,32.0265853 15.9886927,30.9391962 18.617147,30.0192372 C23.9615351,28.1487013 31.3458117,27 39.5,27 Z",
    strokeLinejoin: "square",
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6",
    opacity: 0.61727106
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "url(#linearGradient-8)",
    strokeWidth: 1,
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-11)",
    opacity: 0.569200062,
    filter: "url(#filter-12)",
    points: "0 0 79.75 0 55.672123 51 23.327877 51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u811A,\\u978B\\u5370,\\u8DB3\\u8FF9,\\u8DB3\\u5370",
    transform: "translate(24.000000, 8.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DB3\\u8FF9",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.985089,4.83140136 C16.1768514,4.77698299 17.096962,3.66349969 16.9918065,2.40769148 C16.8822695,1.09746489 15.6773627,-0.0327624993 14.4330226,0.00072572493 C13.184301,0.0342139493 12.4131607,1.01793038 12.5314606,2.41606351 C12.6585235,3.87280108 13.6925526,4.89000572 14.985089,4.83140136 Z M5.31078275,5.91558246 C6.22651193,6.22116246 7.2868299,5.66860683 7.60667788,4.71837863 C7.9615777,3.66349974 7.41389281,2.52908628 6.39300813,2.1942041 C5.43346414,1.88025201 4.42134245,2.39094738 4.09273149,3.35373368 C3.75973905,4.33745011 4.36000172,5.59744437 5.31078275,5.91558246 Z M9.43375474,4.6681463 C10.423969,4.86070357 11.4448537,4.1490789 11.6376388,3.12350216 C11.8523313,1.9849027 11.1206243,0.879791469 10.01211,0.670490087 C8.97369939,0.473746801 7.99662953,1.13932514 7.79508148,2.17745998 C7.58915195,3.24071095 8.39972561,4.467217 9.43375474,4.6681463 Z",
    id: "\\u5F62\\u72B6",
    fill: "#16DD8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38423815,8.49727776 C4.20810788,8.46594535 4.86983304,7.66025546 4.81724561,6.7560923 C4.75589361,5.74897991 3.95393533,4.96119422 3.03365529,5.00147872 C2.17034501,5.0417632 1.53491358,5.79374048 1.58750098,6.71580782 C1.64008841,7.65130332 2.52531012,8.5286101 3.38423815,8.49727776 L3.38423815,8.49727776 Z M2.96792102,9.99228014 C2.80139417,9.15973386 2.37193016,8.41670872 1.24130043,8.51965801 C0.180787271,8.61365519 -0.0777675933,9.38353663 0.0186426857,10.2071308 C0.11943524,11.0486292 0.63654497,11.6976571 1.64885301,11.6528966 C2.71374844,11.60366 2.99421472,10.8561588 2.96792102,9.99228014 Z M17,10.6457842 C17,10.708449 17,10.7755898 16.9956177,10.8472066 C16.9430303,11.7289895 16.7414451,12.4048738 16.6143588,12.7629582 C16.2593937,13.7655946 16.0841023,14.2624367 15.3391137,15.6589659 C13.9893697,18.1789849 13.9543114,20.8511898 13.9367823,22.1044852 C13.9104886,24.1455662 13.8929594,25.2914364 14.637948,26.4014981 C15.098088,27.0863346 15.6634028,27.4891796 16.0402794,28.5500046 C16.0841023,28.6798102 16.4259206,29.6734944 16.3032166,30.6985109 C16.0534263,32.7530204 13.9367823,34.8701944 11.3950565,34.995524 C11.3117931,35 11.2329119,35 11.1540308,35 C8.92344734,35 7.22312047,33.460237 6.48689646,32.1308486 C6.0136096,31.271446 5.84708275,30.3404266 5.78573075,29.9823421 C5.72437877,29.6466381 5.69370275,29.3377902 5.68055588,29.0513227 C5.63235073,28.0442103 5.75943703,27.287757 5.78573075,27.1176669 C6.0136096,25.6405688 5.04512444,22.1358176 3.41929645,19.23981 C2.86274614,18.2506018 2.06517014,17.0375909 2.03437511,15.2650731 C2.03437511,15.2650731 2.03011185,14.7816591 2.09584616,14.2758649 C2.61295589,10.2384632 5.6761736,7.94672298 9.56764337,6.29505863 C10.1329582,6.05782774 11.3074108,5.72659964 12.55198,5.72659964 C13.6782274,5.72659964 14.8570623,5.99516293 15.6984611,6.85008945 C16.9868531,8.15709756 17,10.4219814 17,10.6457842 L17,10.6457842 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5748781,9.79304113 C23.8077296,9.79304113 24.9711248,10.1235174 25.5311175,10.3602099 C29.3859492,12.0036596 32.420327,14.2901983 32.9325681,18.3229022 C32.9849705,18.7915023 32.9887135,19.2408488 32.9890016,19.3026504 L32.9890016,19.3098651 C32.9586142,21.0783599 32.1685474,22.2886177 31.6172369,23.2755806 C30.006716,26.1650152 29.047349,29.6618118 29.2730825,31.1355574 C29.2991286,31.3097272 29.4250184,32.0599978 29.3772671,33.0648243 C29.364244,33.3461759 29.3338569,33.6543225 29.2730825,33.9937306 C29.2123081,34.3510024 29.047349,35.2799087 28.5785181,36.1373607 C27.8492258,37.4637318 26.1649074,39 23.9553246,39 C23.8771861,39 23.7947065,38.995534 23.7165681,38.995534 C21.1987726,38.870489 19.1020566,36.7581203 18.8546181,34.708274 C18.747526,33.8072196 18.9976346,32.930432 19.0883341,32.6460354 L19.1071827,32.5882256 C19.1104029,32.5785561 19.1130606,32.5706679 19.1150797,32.5646441 C19.488408,31.5017608 20.0484005,31.0998301 20.5042083,30.421014 C21.2421829,29.3134718 21.2248187,28.1702024 21.1987726,26.133754 C21.1814085,24.8833032 21.1466803,22.2171633 19.809644,19.702864 C19.0716694,18.3095045 18.8936873,17.81379 18.5464052,16.8134294 C18.4205154,16.4561577 18.2164871,15.7818075 18.1687358,14.902026 C18.1643948,14.8305716 18.1643948,14.7680491 18.1643948,14.7010607 L18.1643948,14.6761494 C18.1665052,14.3456665 18.219296,12.1796684 19.4580208,10.913981 C20.2871569,10.0609949 21.4592342,9.79304113 22.5748781,9.79304113 Z M32.0600217,14.0490399 C32.2249807,13.2183833 32.6504014,12.4770446 33.7703862,12.5752943 C34.8209147,12.669078 35.0770355,13.4372121 34.9815328,14.258937 C34.8816892,15.0985254 34.3694479,15.7460803 33.3666707,15.7014213 C32.3074603,15.6567624 32.0296346,14.9064919 32.0600217,14.0490399 Z M31.9467886,9.0681595 L31.9992473,9.06956602 C32.8500887,9.10975908 33.4838786,9.86449549 33.4317863,10.7800041 C33.3796938,11.7133764 32.5028064,12.588692 31.6519652,12.5574307 C30.8358523,12.5261694 30.176016,11.7223082 30.2324495,10.8201972 C30.2932239,9.81537061 31.0876316,9.02937297 31.9992473,9.06956602 L31.9467886,9.0681595 Z M30.7881009,7.57795679 C31.1180189,8.62297641 30.5232983,9.96721108 29.5812953,10.3066192 C28.6740208,10.6326295 27.6191514,10.0431313 27.3065974,9.03383886 C26.9549742,7.90843311 27.4932616,6.69817534 28.5090618,6.34090365 C29.4597467,6.00596145 30.4625238,6.55080075 30.7881009,7.57795679 Z M20.4836583,4 L20.5432775,4.00077424 C21.7804702,4.03650142 22.5444909,5.08598693 22.4272832,6.57759616 C22.3013934,8.12726198 21.276911,9.21247467 19.9963081,9.15441801 C18.8155489,9.09636138 17.9039332,7.90843311 18.0081179,6.56866434 C18.1166435,5.17083897 19.3104259,3.96504709 20.5432775,4.00077424 L20.4836583,4 Z M24.9277146,4.71085166 C25.956538,4.49648869 26.9245871,5.20656611 27.1242741,6.31857418 C27.3239614,7.44844586 26.5252125,8.76141922 25.5007301,8.9757822 C24.515317,9.18567931 23.5038579,8.42201112 23.3171937,7.32786664 C23.1044834,6.11314296 23.8294348,4.93414646 24.9277146,4.71085166 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-14)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "CO2",
    transform: "translate(4.000000, 23.000000)",
    fill: "#FFFFFF",
    stroke: "#59D744"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.05415379,-0.5 C6.43697893,-0.5 7.5808116,-0.120888391 8.46427263,0.599750318 C9.53309459,1.46395614 10.0937961,2.72242623 10.1323747,4.3395967 L7.11415003,4.3395967 C7.02615235,3.59916986 6.8192377,3.055594 6.36095185,2.74966697 C6.01193507,2.5094838 5.56273376,2.42163153 5.02576995,2.42163153 C4.23408005,2.42163153 3.62292705,2.65898599 3.21023659,3.22416878 C2.79146293,3.77521028 2.61825811,4.54532885 2.61825811,5.51420715 C2.61825811,6.50857821 2.78914226,7.29348349 3.1906,7.82544922 C3.59219878,8.34700143 4.23695488,8.57836847 5.0683457,8.57836847 C5.60710892,8.57836847 6.05861631,8.45666151 6.40009542,8.20198095 C6.87549112,7.8171527 7.13980781,7.16449406 7.26847826,6.31943171 L10.3126847,6.31943171 C10.1682506,8.13486362 9.50759811,9.47771505 8.34808293,10.4023856 C7.44098701,11.1288412 6.35441992,11.5 5.08253762,11.5 C3.12289878,11.5 1.68180593,10.8402724 0.737280082,9.6338547 C-0.0761957565,8.61192662 -0.5,7.24547549 -0.5,5.51420715 C-0.5,3.81577741 -0.0638166663,2.43208187 0.777799263,1.38294808 C1.76086927,0.136389591 3.17577754,-0.5 5.05415379,-0.5 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5419807,-0.5 C17.3262244,-0.5 18.7216684,0.0924642291 19.7466689,1.24887523 C20.7077423,2.32322574 21.2096698,3.74426863 21.2096698,5.51420715 C21.2096698,7.28472417 20.7081798,8.69049252 19.7454622,9.76667747 C18.7190307,10.908381 17.3245825,11.5 15.5419807,11.5 C13.7411362,11.5 12.3457292,10.8909209 11.3337318,9.74711483 C10.3727388,8.65682042 9.88848349,7.25135274 9.88848349,5.51420715 C9.88848349,3.76146852 10.3732684,2.35678362 11.3279539,1.27372789 C12.340627,0.0964582226 13.7372251,-0.5 15.5419807,-0.5 Z M15.5419807,2.42163153 C14.7415056,2.42163153 14.1122476,2.67386905 13.664774,3.22015438 C13.205597,3.7859131 13.0067416,4.55065614 13.0067416,5.51420715 C13.0067416,6.4652342 13.2061338,7.22895499 13.6668473,7.79659567 C14.1021562,8.33041843 14.7434487,8.57836847 15.5419807,8.57836847 C16.3430159,8.57836847 16.975748,8.34139312 17.4135395,7.82643595 C17.8688365,7.27707038 18.0772198,6.50006696 18.0772198,5.51420715 C18.0772198,4.52306067 17.8659784,3.73130999 17.4029221,3.16078289 C16.9717877,2.6429495 16.3392547,2.42163153 15.5419807,2.42163153 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7505987,3.85380385 C24.5355175,3.85380385 25.1769585,4.09442842 25.6928121,4.55352183 C26.2192904,5.03265205 26.4915105,5.64076456 26.4915105,6.41015149 C26.4915105,7.11265641 26.23303,7.75383382 25.7040609,8.34082173 C25.4977959,8.56209769 25.1714309,8.83040494 24.7248242,9.14824264 L24.7,9.165 L26.5,9.16543197 L26.5,11.4990834 L20.8799221,11.4990834 C20.686114,10.3715894 20.9203497,9.43764472 21.5950875,8.67786054 C21.794366,8.4476771 22.1709209,8.12442539 22.7256662,7.72272673 L22.875,7.615 L20.8948184,7.61522094 C20.7420671,6.44834221 20.9675193,5.55401279 21.5124818,4.89164147 L21.6341285,4.75324035 C22.1693941,4.16249716 22.8707224,3.85380385 23.7505987,3.85380385 Z M24.0404362,6.40165289 C23.3975426,6.49151238 23.3095605,6.84426526 23.3050953,7.29207492 L23.305,7.311 L23.4207459,7.22588919 C23.5544535,7.12346448 23.664848,7.03063773 23.7530823,6.94764371 L23.8339725,6.86793596 C23.9593255,6.72332335 24.0404362,6.57034876 24.0404362,6.40165289 Z",
    id: "\\u8DEF\\u5F84"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonFootprint);
export default __webpack_public_path__ + "static/media/carbonFootprint.3ca90fd226a577e456bd4b169ce53b40.svg";
export { ForwardRef as ReactComponent };